import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import InputGroup from 'client/components/form/inputGroup';
import { PasswordRequirements, isPasswordValid } from 'client/components/form/passwordRequirements';
import { email } from 'web-core/src/utils/validate';

const propTypes = {
  submitHandler: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  submitFailHandler: PropTypes.func,
  ctaPath: PropTypes.string,
};

const defaultProps = {
  submitFailHandler: () => {},
  ctaPath: 'common.cta.continue',
};

class CreateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: {
        value: '',
        error: null,
      },
      password: {
        value: '',
        error: null,
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.type !== this.props.type) {
      // clear field errors and reset password field val
      this.setState(
        this.mergeVals(this.state, {
          username: {
            error: null,
          },
          password: {
            value: '',
            error: null,
          },
        }),
      );
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    let newState = this.state;
    newState = this.validateUsername(newState, username.value);
    newState = this.validatePassword(newState, password.value);
    if (newState.username.error || newState.password.error) {
      this.props.submitFailHandler();
      return this.setState(newState);
    }
    const userVal = username.value;
    const passVal = password.value;
    return this.props.submitHandler({
      email: userVal,
      password: passVal,
    });
  };

  mergeVals(state, newVals) {
    return _.merge({}, state, newVals);
  }

  validateUsername(state, username) {
    const newState = {
      username: {
        error: null,
      },
    };
    if (!username) {
      newState.username.error = { path: 'common.form.error.required' };
    } else if (!email.test(username)) {
      newState.username.error = { path: 'common.error.invalidEmail' };
    }
    return this.mergeVals(state, newState);
  }

  validatePassword(state, password) {
    const isLogin = this.props.type === 'login';

    const newState = {
      password: {
        error: null,
      },
    };
    if (!password) {
      newState.password.error = { path: 'common.form.error.required' };
    } else if (isLogin && password.length < 8) {
      newState.password.error = { path: 'common.error.passwordLength' };
    } else if (!isLogin && !isPasswordValid(password)) {
      newState.password.error = { path: 'common.error.passwordRequirements' };
    }
    return this.mergeVals(state, newState);
  }

  render() {
    const { username, password } = this.state;

    const isFormValid =
      this.props.type === 'create'
        ? username.value && email.test(username.value) && isPasswordValid(password.value)
        : username.value && password.value;

    return (
      <div className="create-form pad-top-2 pad-x-small-only">
        <form onSubmit={this.onSubmit}>
          <div>
            <InputGroup
              id="username"
              label={{
                path: 'common.label.email',
              }}
              type="text"
              value={username.value}
              onChange={(e) => {
                const newVal = e.target.value;
                let newState = this.mergeVals(this.state, { username: { value: newVal } });
                if (username.error) {
                  newState = this.validateUsername(newState, newVal);
                }
                this.setState(newState);
              }}
              onBlur={() => {
                this.setState(this.validateUsername(this.state, username.value));
              }}
              error={username.error} />
          </div>
          <div>
            <InputGroup
              autoComplete="off"
              id="password"
              label={{
                path: 'common.label.password',
              }}
              type="password"
              value={password.value}
              onChange={(e) => {
                const newVal = e.target.value;
                let newState = this.mergeVals(this.state, { password: { value: newVal } });
                if (password.error) {
                  newState = this.validatePassword(newState, newVal);
                }
                this.setState(newState);
              }}
              onBlur={() => {
                this.setState(this.validatePassword(this.state, password.value));
              }}
              error={password.error} />
          </div>
          {this.props.type === 'create' && (
            <PasswordRequirements password={password.value} className="margin-bottom" />
          )}
          <Button className="cta-button" isDisabled={!isFormValid} type="submit">
            <Translate path={this.props.ctaPath} />
          </Button>
        </form>
      </div>
    );
  }
}
CreateForm.propTypes = propTypes;
CreateForm.defaultProps = defaultProps;

export default CreateForm;
